import React from 'react'
import { Link } from 'react-router-dom'

const Status = () => {
  return (
    <div className='status'>
      <div>
        <img src='https://cdn0.iconfinder.com/data/icons/everyday-2/64/menu_options_setup_hamburger-512.png' className='hamburger'></img>
      </div>
      <div>
        <img src='https://w7.pngwing.com/pngs/848/762/png-transparent-computer-icons-home-house-home-angle-building-rectangle-thumbnail.png' className='home-button'></img>
      </div>
      <div>
      &#x3E;
      </div>
      <div>
        <h4>DashBoard</h4>
      </div>

    </div>
  )
}

export default Status
